import { Label } from "@/components/ui/label";

/**
 * Thin label + error-message wrapper shared by ContactForm's fields, so the
 * repetitive label/error markup doesn't have to be duplicated per field.
 */
export const FormField = ({ id, label, error, children }) => (
  <div>
    <Label htmlFor={id} className="text-slate-700">{label}</Label>
    {children}
    {error && (
      <p id={`${id}-error`} className="mt-1 text-xs text-red-600">{error}</p>
    )}
  </div>
);
